import React from 'react';
import {
  CheckCircle2, Eye, FileCheck2, FileText, Mail, MailWarning, PenLine, RefreshCw, Send, UserCheck, UserPlus, UserX, XCircle
} from 'lucide-react';
import { STEP_LABELS } from '../../application/stepConfig';
import { formatDisplayDateTime } from '../../../utils/dateInput';

const EVENTS = {
  invite_sent: { icon: Mail, label: 'Invite sent' },
  invite_resent: { icon: RefreshCw, label: 'Invite re-sent' },
  invite_reminder_sent: { icon: Mail, label: 'Reminder sent' },
  invite_accepted: { icon: UserPlus, label: 'Applicant created their account' },
  invite_expired: { icon: MailWarning, label: 'Invite expired' },
  invite_revoked: { icon: UserX, label: 'Invite withdrawn' },
  step_completed: { icon: CheckCircle2, label: (meta) => `Completed ${STEP_LABELS[meta?.step] || 'a step'}` },
  submitted: { icon: Send, label: 'Application submitted and signed' },
  resubmitted: { icon: Send, label: 'Updated application resubmitted and signed' },
  viewed_by_reviewer: { icon: Eye, label: 'First opened by a reviewer' },
  changes_requested: { icon: PenLine, label: (meta) => `Changes requested${meta?.sections?.length ? `: ${meta.sections.map((s) => STEP_LABELS[s] || s).join(', ')}` : ''}` },
  approved: { icon: FileCheck2, label: (meta) => `Approved and signed${meta?.title ? ` (${meta.title})` : ''}` },
  rejected: { icon: XCircle, label: 'Closed as not selected' },
  hired: { icon: UserCheck, label: (meta) => `Hired${meta?.driverCode ? ` as ${meta.driverCode}` : ''}` },
  pdf_regenerated: { icon: FileText, label: (meta) => `${meta?.version === 'final' ? 'Signed' : 'Submitted'} PDF regenerated` }
};

const describe = (entry) => {
  const def = EVENTS[entry.event];
  if (!def) return { icon: FileText, label: entry.event.replace(/_/g, ' ') };
  return { icon: def.icon, label: typeof def.label === 'function' ? def.label(entry.meta) : def.label };
};

/**
 * Newest-first activity list for an application.
 */
const ApplicationTimeline = ({ timeline = [] }) => {
  const entries = [...timeline].sort((a, b) => new Date(b.at) - new Date(a.at));
  if (!entries.length) return <p className="text-sm text-gray-500">No activity yet.</p>;
  return (
    <ol className="space-y-4">
      {entries.map((entry, index) => {
        const { icon: Icon, label } = describe(entry);
        return (
          <li key={entry.id || index} className="flex gap-3">
            <span className="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-600">
              <Icon className="h-4 w-4" aria-hidden="true" />
            </span>
            <div className="min-w-0">
              <p className="text-sm text-gray-900">{label}</p>
              <p className="text-xs text-gray-500">
                {formatDisplayDateTime(entry.at)}
                {entry.by?.name && entry.by.name !== 'System' ? ` · ${entry.by.name}` : ''}
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default ApplicationTimeline;
